'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'cowbell-circle-plus';
var width = 576;
var height = 512;
var aliases = ["cowbell-more"];
var unicode = 'f8b4';
var svgPathData = 'M216 32l80 0c4.4 0 8 3.6 8 8l0 24-96 0 0-24c0-4.4 3.6-8 8-8zm-56 8l0 24c-28.5 .6-53.3 20-60.6 47.7l-66 251c-.9 3.5-1.4 7.2-1.4 10.8 0 23.5 19 42.5 42.5 42.5l166.2 0c-.4-5.3-.7-10.6-.7-16 0-106 86-192 192-192 2 0 4 0 5.9 .1l-25.4-96.4C405.3 84 380.5 64.6 352 64l0-24c0-30.9-25.1-56-56-56l-80 0c-30.9 0-56 25.1-56 56zm17.6 424c7.4 36.5 39.7 64 78.4 64 10 0 19.6-1.8 28.4-5.2-14.4-17.3-25.8-37.2-33.5-58.8l-73.3 0zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCowbellCirclePlus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;